<template lang="pug">
  v-layout(column justify-center align-center)
    v-progress-circular(indeterminate :size="size" :width="width" color="primary")
    br
    p Caricamento...
</template>

<script>
export default {
  name: "Loading",

  props: {
    width: {
      default: 7
    },
    size: {
      default: 70
    }
  }
};
</script>
